import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { filter, Subscription } from 'rxjs';
import { AdminLayoutService } from '../../layouts/admin-layout/admin-layout.service';

export interface IModalFooterMenuItem {
  icon: string;
  translationText: string;
  tooltip?: string;
  action: () => void;
  isLoading?: () => boolean;
  isDisabled?: () => boolean;
  isActive?: () => boolean;
}

export const MODAL_FOOTER_MENU_SPACER_CONTAINER_SELECTOR = '.outlet > *:nth-child(2)';

@Component({
  selector: 'app-modal-footer-menu',
  standalone: true,
  imports: [
    TranslateModule,
    NgbTooltipModule,
  ],
  templateUrl: './modal-footer-menu.component.html',
  styleUrl: './modal-footer-menu.component.scss'
})
export class ModalFooterMenuComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input({required: true}) items: IModalFooterMenuItem[] = [];
  @Input() selectorToHandleSpacer: string | null = null; // This is used to handle padding for the footer menu, so it doesn't overlap with the content below it

  footerMenuSpacerClass = 'modal-footer-menu-spacer';

  subs: Subscription[] = [];
  constructor(
    private elRef: ElementRef,
    private router: Router,
    private adminLayoutService: AdminLayoutService
  ) {}

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.handlePadding();
    
    // handle padding when routing changes
    this.subs.push(
      this.router.events.pipe(
        filter((e) => e instanceof NavigationEnd)
      ).subscribe(() => {
        this.removePadding();
        this.handlePadding();
      }),

      this.adminLayoutService.secondaryContentAttached$.subscribe((v) => {
        if (v) {
          this.removePadding();
          setTimeout(() => {
            this.handlePadding();
          })
        }
      })
    );
  }

  private handlePadding() {
    if (!this.selectorToHandleSpacer) return;

    
    const footerMenuHeight = this.elRef.nativeElement.offsetHeight;
    const elementsToHandlePadding = document.querySelectorAll(this.selectorToHandleSpacer);

    elementsToHandlePadding.forEach((element: Element) => {
      const el = element as HTMLElement;
      
      // instead of padding, create new element with height
      const paddingElement = document.createElement('div');
      paddingElement.style.height = `${footerMenuHeight}px`;
      paddingElement.style.minHeight = `${footerMenuHeight}px`;
      paddingElement.style.maxHeight = `${footerMenuHeight}px`;
      paddingElement.classList.add(this.footerMenuSpacerClass);
      el.insertAdjacentElement('beforeend', paddingElement);
    })
  }
  
  private removePadding() {
    // Remove padding elements
    const paddingElements = document.querySelectorAll(`.${this.footerMenuSpacerClass}`);
    paddingElements.forEach((element: Element) => {
      const el = element as HTMLElement;
      el.remove();
    });
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
    
    this.removePadding();
  }
}
